/* eslint-disable import/prefer-default-export */
export const errorCodeHandler = (context, error) => {
  if (error === 'DUPLICATE_BOOKING_NOT_ACKNOWLEDGED') {
    context.commit('bookings/setDuplicateBooking', true);

    return false;
  }

  return true;
};
